// CUSTOM CODE

jQuery(document).ready(function($) {

  // Announcement bar rotator.
  // Bails out when the toolbar arrows are not rendered (single announcement).
  // Previously this threw an uncaught TypeError every 12 seconds on every page.
  setInterval(function() {
    var next = $('[data-header-toolbar-direction="next"]');
    var prev = $('[data-header-toolbar-direction="previous"]');
    if (!next.length || !prev.length) return;
    if (next.attr('data-disabled') === 'false') {
      next[0].click();
    } else {
      prev[0].click();
    }
  }, 12000);

  $('body.template-product .product-block--product_label').on('click', function(e) {
    e.preventDefault();
    window.location = 'https://www.fishersfinery.com/pages/sustainability';
  });
  
});

// ---------- Zoom modal: lift its ancestor chain while it is open ----------
// The modal is rendered inside .product-gallery, in the gallery column. Some ancestor
// in that chain confines it to a stacking context, so it opens UNDERNEATH the header
// and the details column and its close button cannot be reached.
// The modal element is NOT moved: the theme's gallery component resolves it by DOM
// position, so relocating it stops the zoom button working entirely.
// Instead, while the modal is open, every ancestor from its parent up to <body> is
// given a very high z-index and has the properties that create a stacking context
// neutralised. Everything is restored on close, so nothing persists.
(function () {
  if (!/\btemplate-product\b/.test(document.body.className)) return;

  var LIFT = '2147483000';
  var KILL = ['transform', 'filter', 'backdrop-filter', 'perspective', 'will-change', 'contain', 'isolation', 'mix-blend-mode'];
  var lifted = [];

  function lift() {
    if (lifted.length) return;
    var modal = document.querySelector('.product-gallery-modal');
    if (!modal) return;

    var el = modal;
    while (el && el !== document.body) {
      var saved = { el: el, style: el.getAttribute('style') };
      if (getComputedStyle(el).position === 'static') {
        el.style.setProperty('position', 'relative', 'important');
      }
      el.style.setProperty('z-index', LIFT, 'important');
      KILL.forEach(function (p) {
        el.style.setProperty(p, p === 'will-change' || p === 'isolation' ? 'auto' : 'none', 'important');
      });
      lifted.push(saved);
      el = el.parentElement;
    }
  }

  function drop() {
    lifted.forEach(function (s) {
      if (s.style === null) {
        s.el.removeAttribute('style');
      } else {
        s.el.setAttribute('style', s.style);
      }
    });
    lifted = [];
  }

  // Open: the zoom button. Capture phase so it runs before the theme's own handler,
  // and the actual lift is deferred a tick so the modal is open when it happens.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-product-gallery-media-zoom], .product-gallery__media-zoom')) {
      setTimeout(lift, 0);
      return;
    }
    if (t.closest('[data-product-gallery-modal-close], .product-gallery-modal__toggle')) {
      setTimeout(drop, 250);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setTimeout(drop, 250);
  });

  // Backstop: whatever path closed it, body releases the scroll lock. Restore then.
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (lifted.length && getComputedStyle(document.body).overflow !== 'hidden') drop();
    }).observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
  }
})();

// PDP GALLERY LAYOUT - preview, move CSS to custom.css once approved
// Runs on every product template (body class is template-product or template-product-<suffix>).
// Desktop:
//   1. Sizes the image to fit the window height.
//   2. Lays out gallery + details as a two-column grid that responds to window width
//      (details column grows up to a cap; the pair centers on very wide screens).
//   3. Makes the gallery column sticky while the details column scrolls.
// All sizes:
//   4. Removes the sand background behind thumbnails.
//   7. Moves the free gift callout block below the quantity selector.
//   8. Shows a centered free shipping / exchanges / returns icon row under Add to cart.
// Mobile:
//   5. Shows a horizontal thumbnail strip under the main image.
//   6. Moves the blocks above the title (rating, statement) above the product image.
// Note: StarApps (variant images) hides the theme gallery with an inline display:none
// and inserts its own copy. Everything below targets the gallery that is actually showing.
(function () {
  var body = document.body;
  if (!body || !/\btemplate-product\b/.test(body.className)) return;
  if (!document.querySelector('[data-product-grid]')) return;

  var css =
    '.product-gallery__navigation-thumbnail--background-secondary,' +
    '.product-gallery__navigation-thumbnail--background-secondary *:not(.product-gallery__navigation-thumbnail-icon):not(.product-gallery__navigation-thumbnail-icon *) {' +
      'background-color: transparent !important;' +
      'background-image: none !important;' +
    '}' +
    '.product-gallery__navigation-thumbnail--style-fit img {' +
      'width: 100% !important;' +
      'height: 100% !important;' +
      'object-fit: cover !important;' +
    '}' +
    '[data-product-gallery-navigation-thumbnails].ff-thumbs-scroll {' +
      'scrollbar-width: none;' +
    '}' +
    '[data-product-gallery-navigation-thumbnails].ff-thumbs-scroll::-webkit-scrollbar {' +
      'display: none;' +
    '}' +
    '.ff-mobile-head { display: none; }' +
    '@media screen and (max-width: 991px) {' +
      '.ff-mobile-head { display: block; margin: 0 0 12px; }' +
      /* Stack the gallery: main image first, thumbnail strip underneath.
         Skip any gallery an app has hidden with an inline display:none. */
      '.product-gallery--thumbnail-navigation:not([style*="display: none"]):not([style*="display:none"]) {' +
        'display: flex !important;' +
        'flex-direction: column !important;' +
        'height: auto !important;' +
        'grid-template-columns: none !important;' +
        'grid-template-rows: none !important;' +
        'grid-template-areas: none !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation > * {' +
        'grid-area: auto !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation > [data-product-gallery-list] {' +
        'order: 1 !important;' +
        'width: 100% !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation > .product-gallery-navigation__thumbnails-wrapper {' +
        'order: 2 !important;' +
        'display: block !important;' +
        'position: relative !important;' +
        'inset: auto !important;' +
        'z-index: auto !important;' +
        'width: 100% !important;' +
        'height: auto !important;' +
        'max-height: none !important;' +
        'margin: 12px 0 0 !important;' +
        'padding: 0 !important;' +
        'transform: none !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation [data-product-gallery-navigation-thumbnails] {' +
        'position: relative !important;' +
        'inset: auto !important;' +
        'z-index: auto !important;' +
        'display: flex !important;' +
        'flex-direction: row !important;' +
        'flex-wrap: nowrap !important;' +
        'align-items: flex-start !important;' +
        'gap: 8px !important;' +
        'width: 100% !important;' +
        'height: auto !important;' +
        'max-height: none !important;' +
        'margin: 12px 0 0 !important;' +
        'padding: 2px 0 !important;' +
        'overflow-x: auto !important;' +
        'overflow-y: hidden !important;' +
        'transform: none !important;' +
        'scrollbar-width: none;' +
        '-webkit-overflow-scrolling: touch;' +
      '}' +
      '.product-gallery--thumbnail-navigation [data-product-gallery-navigation-thumbnails]::-webkit-scrollbar { display: none; }' +
      '.product-gallery--thumbnail-navigation .product-gallery__navigation-thumbnail {' +
        'position: relative !important;' +
        'flex: 0 0 64px !important;' +
        'width: 64px !important;' +
        'max-width: 64px !important;' +
        'height: 64px !important;' +
        'max-height: 64px !important;' +
        'aspect-ratio: 1 / 1 !important;' +
        'overflow: hidden !important;' +
        'margin: 0 !important;' +
        'padding: 0 !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation .product-gallery__navigation-thumbnail > div:not(.product-gallery__navigation-thumbnail-icon) {' +
        'position: absolute !important;' +
        'inset: 0 !important;' +
        'width: 100% !important;' +
        'height: 100% !important;' +
        'padding: 0 !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation .product-gallery__navigation-thumbnail img,' +
      '.product-gallery--thumbnail-navigation .product-gallery__navigation-thumbnail canvas {' +
        'width: 100% !important;' +
        'height: 100% !important;' +
        'object-fit: cover !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation .product-gallery__navigation-thumbnail-icon {' +
        'position: absolute !important;' +
        'top: 4px !important;' +
        'right: 4px !important;' +
        'z-index: 2 !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation .product-gallery__navigation-thumbnail-link {' +
        'position: absolute !important;' +
        'inset: 0 !important;' +
        'z-index: 3 !important;' +
      '}' +
      '.product-gallery--thumbnail-navigation .product-gallery-navigation__arrows { display: none !important; }' +
    '}';
  var style = document.createElement('style');
  style.id = 'ff-pdp-gallery-tweaks';
  style.textContent = css;
  document.head.appendChild(style);

  var mq = window.matchMedia('(min-width: 992px)');
  var BOTTOM_GAP = 24;   // space under the image at page load
  var STICKY_GAP = 16;   // space under the header when pinned
  var MIN_HEIGHT = 360;  // never shrink the image below this height
  var COL_GAP = 88;      // space between image and details
  var DETAILS_MIN = 360; // details column never narrower than this
  var DETAILS_MAX = 680; // details column never wider than this

  var grid = document.querySelector('[data-product-grid]');
  var galleryCol = grid.querySelector('.product__grid-column--gallery');
  var detailsCol = grid.querySelector('.product__grid-column--details');

  var GRID_PROPS = ['display', 'grid-template-columns', 'column-gap', 'justify-content', 'align-items'];
  var GALLERY_PROPS = ['grid-column', 'width', 'max-width', 'flex', 'margin', 'position', 'top', 'align-self'];
  var DETAILS_PROPS = ['grid-column', 'width', 'max-width', 'flex', 'margin', 'padding-left', 'position'];

  function clear(el, props) {
    if (!el) return;
    props.forEach(function (p) { el.style.removeProperty(p); });
  }
  function setImp(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  // Scroll is locked while the zoom modal or a drawer is open. Skip measuring then,
  // and recompute once scroll is released.
  function scrollLocked() {
    return getComputedStyle(document.body).overflow === 'hidden';
  }

  // ---------- Free gift callout: place it right below the quantity selector ----------
  // Permanent fix is to drag the block below Quantity in the theme editor; this keeps
  // every product template consistent until then and does nothing once it is already there.
  (function moveGiftBelowQuantity() {
    if (!detailsCol) return;
    var qty = null;
    var blocks = Array.prototype.slice.call(detailsCol.children);
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].classList.contains('product-block--quantity_selector')) { qty = blocks[i]; break; }
    }
    if (!qty) return;
    blocks.forEach(function (b) {
      if (b === qty || !b.querySelector('.ff-gift-callout')) return;
      if (b.compareDocumentPosition(qty) & Node.DOCUMENT_POSITION_FOLLOWING) {
        qty.parentNode.insertBefore(b, qty.nextSibling);
      }
    });
  })();

  // ---------- Free shipping / exchanges / returns icon row under Add to cart ----------
  // Styles live in custom.css under PERKS ROW.
  // 1. If the template has the "Free shipping, exchanges & returns" text block, that block
  //    is converted in place.
  // 2. Otherwise the row is added right after the Add to cart block.
  // Never added where the promise may not apply: outlet templates, products showing the
  // final sale note (.finalsale), gift card templates, and pages without Add to cart.
  (function perksRow() {
    if (!detailsCol) return;
    var ICONS = {
      shipping: '<path d="M2.75 6.75h10.5v8.5H2.75z"/><path d="M13.25 9.75h3.9l3.1 3.1v2.4h-7"/><circle cx="6.5" cy="16.75" r="1.75"/><circle cx="16.75" cy="16.75" r="1.75"/>',
      exchanges: '<path d="M4 8.25h14.5"/><path d="M15.25 5l3.25 3.25-3.25 3.25"/><path d="M20 15.75H5.5"/><path d="M8.75 12.5 5.5 15.75 8.75 19"/>',
      returns: '<path d="M9.25 13.75 4.5 9l4.75-4.75"/><path d="M4.5 9h9.75a5.5 5.5 0 0 1 0 11h-3"/>'
    };
    var ITEMS = [
      ['shipping', 'Free shipping'],
      ['exchanges', 'Free exchanges'],
      ['returns', 'Free returns']
    ];
    function listHtml() {
      var html = '<ul class="ff-perks">';
      ITEMS.forEach(function (it) {
        html += '<li class="ff-perks__item">' +
          '<svg class="ff-perks__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICONS[it[0]] + '</svg>' +
          '<span class="ff-perks__label">' + it[1] + '</span></li>';
      });
      return html + '</ul>';
    }

    var found = false;
    Array.prototype.forEach.call(detailsCol.children, function (b) {
      if (!b.classList.contains('product-block--text')) return;
      if (b.querySelector('.ff-perks')) { found = true; return; }
      var t = (b.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.length > 80 || t.indexOf('shipping') === -1 || t.indexOf('exchange') === -1 || t.indexOf('return') === -1) return;
      b.innerHTML = listHtml();
      b.classList.add('ff-perks-block');
      found = true;
    });
    if (found) return;

    if (/\btemplate-product-(outlet|gift-card)/.test(body.className)) return;
    if (document.querySelector('.finalsale')) return;

    var buy = null;
    for (var i = 0; i < detailsCol.children.length; i++) {
      if (detailsCol.children[i].classList.contains('product-block--buy_buttons')) {
        buy = detailsCol.children[i];
        break;
      }
    }
    if (!buy) return;

    var blk = document.createElement('div');
    blk.className = 'product-block product-block--text ff-perks-block';
    blk.innerHTML = listHtml();
    buy.parentNode.insertBefore(blk, buy.nextSibling);
  })();

  // ---------- Find the gallery that is actually showing ----------
  function activeGallery() {
    var gs = grid.querySelectorAll('.product-gallery');
    for (var i = gs.length - 1; i >= 0; i--) {
      if (getComputedStyle(gs[i]).display !== 'none') return gs[i];
    }
    return gs[0] || null;
  }
  function getList() {
    var g = activeGallery();
    return g ? g.querySelector('[data-product-gallery-list]') : null;
  }
  function getThumbs() {
    var g = activeGallery();
    return g ? g.querySelector('[data-product-gallery-navigation-thumbnails]') : null;
  }

  // ---------- Mobile: move blocks above the title to above the image ----------
  var mobileHead = null;
  var moved = [];

  (function setupMobileHead() {
    if (!galleryCol || !detailsCol) return;
    var titleBlock = null;
    for (var i = 0; i < detailsCol.children.length; i++) {
      if (detailsCol.children[i].classList.contains('product-block--title')) {
        titleBlock = detailsCol.children[i];
        break;
      }
    }
    if (!titleBlock) return;

    var blocks = [];
    for (var el = detailsCol.firstElementChild; el && el !== titleBlock; el = el.nextElementSibling) {
      if (!el.classList.contains('product-block')) continue;
      if (el.querySelector('#buy-box')) continue; // keep jump-link anchor in place
      blocks.push(el);
    }
    if (!blocks.length) return;

    mobileHead = document.createElement('div');
    mobileHead.className = 'ff-mobile-head';
    var anchor = galleryCol.querySelector('.mobile-title') || galleryCol.firstElementChild;
    galleryCol.insertBefore(mobileHead, anchor);

    moved = blocks.map(function (b) {
      var ph = document.createComment('ff-mobile-head-placeholder');
      b.parentNode.insertBefore(ph, b);
      return { el: b, ph: ph };
    });
  })();

  function placeHead(isDesktop) {
    if (!mobileHead) return;
    moved.forEach(function (m) {
      if (isDesktop) {
        if (m.ph.nextSibling !== m.el) m.ph.parentNode.insertBefore(m.el, m.ph.nextSibling);
      } else if (m.el.parentNode !== mobileHead) {
        mobileHead.appendChild(m.el);
      }
    });
  }

  // ---------- Mobile: thumbnail strip navigation ----------
  function selectThumb(thumbs, li) {
    if (!thumbs || !li) return;
    Array.prototype.forEach.call(thumbs.children, function (t) {
      t.removeAttribute('data-media-selected');
    });
    li.setAttribute('data-media-selected', '');
    var left = li.offsetLeft - (thumbs.clientWidth - li.offsetWidth) / 2;
    thumbs.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  (function setupMobileThumbs() {
    // Delegated, so it works for whichever gallery copy is showing, even if an app adds it later
    grid.addEventListener('click', function (e) {
      if (mq.matches) return;
      var thumbs = e.target.closest('[data-product-gallery-navigation-thumbnails]');
      if (!thumbs) return;
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var gallery = thumbs.closest('.product-gallery');
      var list = gallery && gallery.querySelector('[data-product-gallery-list]');
      if (!list) return;
      var id = link.getAttribute('href').slice(1);
      var target = null;
      for (var i = 0; i < list.children.length; i++) {
        if (list.children[i].id === id) { target = list.children[i]; break; }
      }
      if (!target) return;
      e.preventDefault();
      var first = list.firstElementChild;
      list.scrollTo({ left: target.offsetLeft - (first ? first.offsetLeft : 0), behavior: 'smooth' });
      selectThumb(thumbs, link.closest('li'));
    });

    var scrollTimer;
    grid.addEventListener('scroll', function (e) {
      if (mq.matches) return;
      var list = e.target;
      if (!list || !list.matches || !list.matches('[data-product-gallery-list]')) return;
      var gallery = list.closest('.product-gallery');
      var thumbs = gallery && gallery.querySelector('[data-product-gallery-navigation-thumbnails]');
      if (!thumbs) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = list.firstElementChild ? list.firstElementChild.offsetWidth : list.clientWidth;
        if (!w) return;
        var index = Math.round(list.scrollLeft / w);
        var slide = list.children[index];
        if (!slide) return;
        var mediaEl = slide.querySelector('[data-media]');
        if (!mediaEl) return;
        var thumb = thumbs.querySelector('[data-media="' + mediaEl.getAttribute('data-media') + '"]');
        if (thumb && !thumb.hasAttribute('data-media-selected')) selectThumb(thumbs, thumb);
      }, 80);
    }, { capture: true, passive: true });
  })();

  // ---------- Desktop layout ----------
  function stickyTop() {
    var header = document.querySelector('.section-header') ||
      document.querySelector('[data-header-section]');
    if (!header) return STICKY_GAP;
    var hs = getComputedStyle(header);
    if (hs.position !== 'sticky' && hs.position !== 'fixed') return STICKY_GAP;
    var offset = parseFloat(hs.top) || 0;
    return Math.max(0, Math.round(header.offsetHeight + offset)) + STICKY_GAP;
  }

  function layout() {
    if (scrollLocked()) return;

    var list = getList();
    var thumbs = getThumbs();

    placeHead(mq.matches);
    if (!list || !galleryCol || !detailsCol) return;

    // Reset to the theme's own layout before measuring
    list.style.removeProperty('max-width');
    clear(grid, GRID_PROPS);
    clear(galleryCol, GALLERY_PROPS);
    clear(detailsCol, DETAILS_PROPS);
    if (thumbs) {
      thumbs.style.removeProperty('max-height');
      thumbs.style.removeProperty('overflow-y');
      thumbs.classList.remove('ff-thumbs-scroll');
    }

    if (!mq.matches) return;

    var media = list.querySelector('.product-gallery__media');
    if (!media || !media.offsetHeight) return;

    // Image size that fits the window height
    var ratio = media.offsetWidth / media.offsetHeight;
    if (!isFinite(ratio) || ratio <= 0) return;
    var top = list.getBoundingClientRect().top + window.scrollY;
    var availH = Math.max(MIN_HEIGHT, window.innerHeight - top - BOTTOM_GAP);
    var imageW = Math.floor(availH * ratio);

    // Width taken by the thumbnail strip (and its gap) to the left of the image
    var extra = Math.max(0, list.getBoundingClientRect().left - galleryCol.getBoundingClientRect().left);

    // Space available inside the grid
    var gs = getComputedStyle(grid);
    var gridW = grid.clientWidth - (parseFloat(gs.paddingLeft) || 0) - (parseFloat(gs.paddingRight) || 0);

    // Hard clamp: the two columns plus the gap can never exceed the grid.
    var maxImageW = gridW - extra - COL_GAP - DETAILS_MIN;
    if (!isFinite(gridW) || gridW <= 0 || maxImageW < 200) return;
    imageW = Math.min(imageW, maxImageW);
    if (imageW < 200) return;

    var detailsW = Math.min(DETAILS_MAX, gridW - extra - imageW - COL_GAP);
    if (detailsW < DETAILS_MIN) {
      // Narrow desktop: shrink the image so details keep a usable width
      imageW = Math.max(200, imageW - (DETAILS_MIN - detailsW));
      detailsW = Math.min(DETAILS_MAX, gridW - extra - imageW - COL_GAP);
    }
    if (detailsW < 200) return;

    var galleryW = Math.ceil(extra + imageW);

    // Take over the two-column layout so it responds to window width
    list.style.setProperty('max-width', imageW + 'px');
    setImp(grid, 'display', 'grid');
    setImp(grid, 'grid-template-columns', galleryW + 'px ' + Math.floor(detailsW) + 'px');
    setImp(grid, 'column-gap', COL_GAP + 'px');
    setImp(grid, 'justify-content', 'center');
    setImp(grid, 'align-items', 'start');

    setImp(galleryCol, 'grid-column', '1');
    setImp(galleryCol, 'width', 'auto');
    setImp(galleryCol, 'max-width', 'none');
    setImp(galleryCol, 'flex', 'none');
    setImp(galleryCol, 'margin', '0');

    setImp(detailsCol, 'grid-column', '2');
    setImp(detailsCol, 'width', 'auto');
    setImp(detailsCol, 'max-width', 'none');
    setImp(detailsCol, 'flex', 'none');
    setImp(detailsCol, 'margin', '0');
    setImp(detailsCol, 'padding-left', '0');

    // Keep thumbnails within the image height so the pinned column fits on screen
    if (thumbs && thumbs.scrollHeight > list.offsetHeight) {
      thumbs.style.maxHeight = list.offsetHeight + 'px';
      thumbs.style.overflowY = 'auto';
      thumbs.classList.add('ff-thumbs-scroll');
    }

    // Sticky gallery, scrolling details
    if (detailsCol.offsetHeight > galleryCol.offsetHeight + 40) {
      setImp(galleryCol, 'position', 'sticky');
      setImp(galleryCol, 'top', stickyTop() + 'px');
      setImp(galleryCol, 'align-self', 'start');
      setImp(detailsCol, 'position', 'static');
    }
  }

  var timer;
  function queueLayout() {
    clearTimeout(timer);
    timer = setTimeout(layout, 100);
  }

  // Re-run when an app swaps in its own gallery copy
  if (galleryCol && window.MutationObserver) {
    new MutationObserver(queueLayout).observe(galleryCol, { childList: true });
  }

  // Re-run once the modal or drawer closes and scroll is released
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (!scrollLocked()) queueLayout();
    }).observe(body, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  layout();
  window.addEventListener('load', layout);
  window.addEventListener('resize', queueLayout);
})();
